// extracted by mini-css-extract-plugin
module.exports = {"mobile":"MobileCard_mobile__4pKH_","header":"MobileCard_header__wt6xW","headline":"MobileCard_headline__10YTz"};